<template>
  <div class="popup-wrapper" @click.self="close"
    :class="{'is-focused-input__popup': state.isFocusedInput}"
    >
    <div class="popup-action" v-if="!state.isFocusedInput">
      <div class="button button-submit">
        <div role="button" class="btn"
          @click="close"
        >閉じる
        </div>
      </div>
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">

        <FontawesomeIcon v-if="!state.isDataLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
        <template v-else>
          <p v-if="state.allList.length === 0">共有されたアカウントがありません。</p>
          <template v-else>
            <form @submit.prevent="state.search">
              <div class="popup-title" v-if="!state.isFocusedInput">
                <p class="popup-title-main">{{ state.windowTitle }}</p>
              </div>
              <div class="popup-content">
                <div class="formparts function suggest">
                  <input v-model="state.search_text" type="text" placeholder="キーワード" ref="focusInput">
                  <div @click="state.search" class="button" role="button"><FontawesomeIcon icon="search" class="icn" /></div>
                  <ul class="suggest-list" v-if="!state.isFocusedInput">
                    <li v-for="(item, index) in state.list" :key="index"
                      v-show="item.id !== state.profileId">
                      <div>
                        <label>{{ item.name }}</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </form>
          </template>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted } from '@vue/composition-api'

import { NoteUserPermissionsList } from '@/logic/note/NoteUserPermissionsList'

export default defineComponent({
  name: 'SPNoteUserPermissionsList',
  setup (props, context) {
    return {
      ...NoteUserPermissionsList(props, context)
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  height: 100%;
  &-content {
    padding: 20px;
  }
}
.is-focused-input__popup {
  .popup {
    background-color: transparent;
  }
  &:before {
    background-color: rgba(0,0,0,.6);
  }
  .formparts.function.suggest {
    position: fixed;
    top: 20px;
    left: 20px;
    right: 20px;
    .button {
      border-bottom-right-radius: 5px!important;
    }
  }
}

</style>
